import type { StyleValue } from 'vue';
import { thumbHashToAverageRGBA, thumbHashToDataURL } from 'thumbhash';

/**
 * Blur-up placeholder style for an image's meta.thumbhash (base64), to put on the element behind the image.
 * SSR renders only the average colour: a full data URL is ~5KB, times 80 tiles on /products.
 * The blurred preview is decoded in the browser once mounted.
 */
export default function useThumbhash(): (thumbhash?: string) => StyleValue {
    const mounted = useMounted();

    return thumbhash => {
        if (!thumbhash) {
            return {};
        }

        const bytes = Uint8Array.from(atob(thumbhash), char => char.charCodeAt(0));

        if (!mounted.value) {
            const { r, g, b } = thumbHashToAverageRGBA(bytes);

            return { backgroundColor: `rgb(${[r, g, b].map(channel => Math.round(channel * 255)).join(' ')})` };
        }

        return {
            backgroundImage: `url('${thumbHashToDataURL(bytes)}')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        };
    };
}
